<article class="page-wrapper h-100 d-flex flex-column justify-content-center align-items-center">
    <section class="image-wrapper mt-5">
        <img src="../../../../../../../assets/gif/finzy-flex/lrs-empty.svg" alt="lrs empty" class="image" />
    </section>
    <section class="text-section">
        <div class="header-label text-center px-4">
            <span>Investor Return Schedule</span>
        </div>
        <div class="header-desc text-center mt-3 px-4">
            <span>Looks like you are yet to start investments, click <strong class="invest">“Invest Now”</strong> to start your investment journey</span>
        </div>
    </section>
    <section class="btn-section m-4">
        <button (click)="goToInvestNowPage()" class="invest-btn">
            Invest Now
        </button>
    </section>
</article>